import * as Yup from 'yup'
import { InEditingMode, InEditingWhatsNew } from "../../states/GlobalState"
import Api from '../../services/api'
// import DateFnsUtils from '@date-io/date-fns'
// import { it } from 'date-fns/locale';
import ValidationCache from '../../utils/validationCache';
import { OptionType } from '../../types/constants';
import uuid from 'uuidv4'
import { WhatsNew } from '../../models/whatsNew';

const passwordValidationRegex = /^.*(?=.{8,})(?=.*\d)(?=.*[@#$%^&+=_.!])(?=.*[A-Z]).*$/
const passwordValidationHint = "La password deve essere lunga almeno 8 caratteri, contenere almeno un numero, un carattere maiuscolo ed un carattere speciale: @#$%^&+=_.!"
const validationCache = new ValidationCache('default', 60000);

const setCacheName = (newName: string) => {
    validationCache.setName(newName)
}
const clearCache = () => {
    validationCache.clear()
}
const reformatQuery = (query: string) => {
    let q = query.replace(/[_]/g, '[_]').replace(/[*]/g, '%')
    if(q.endsWith('$')) {
        console.log('query finisce per $')
        q = q.replace(/[$]$/, '')
    } else if(!q.endsWith('%')) {
        q += '%'
    }
    q = q.replace(/%/g, '%25').replace(/[ ]/g, '%20').replace(/#/g, '%23')
    return q
}

// const dateFns = new DateFnsUtils({locale: it})
// const isExpired = (pwexp: DateTimeISO) => {
//     return dateFns.date(pwexp).getTime() < Date.now()
// }

// const isAcceptable = (ubo: WhatsNew, filters: UsersFilterType) => {
//     return !(
//         (filters.pwExpireFilter && ((filters.noPwExpire && isExpired(ubo.pwExpire)) || (!filters.noPwExpire && !isExpired(ubo.pwExpire)))) ||
//         (filters.lockedFilter && ((!filters.onlyLocked && ubo.isLocked) || (filters.onlyLocked && !ubo.isLocked)))
//     )
// }

// const newInEditWhatsNew = (newId: number) => {
//     const newWhatsNew: InEditingWhatsNew = {
//         Id: newId,
//         BusinessName: '',
//         VatNumber: '',
//         TaxCode: '',
//         UiLogoUrl: '',
//         InsertDate: '',
//         InsertUser: '',
//         UpdateDate: '',
//         UpdateUser: '',
//         IsLocked: false,
//         modified: true,
//         mode: InEditingMode.New,
//     }
//     return newWhatsNew
// }

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export class CompanyServiceValidation {
    levels: OptionType[];
    // ownerContext: string;
    // checkOwnerContextErrorMessage: string;
    constructor(adLevels: OptionType[]) {
        this.levels = adLevels;
        // this.ownerContext = adOwnerContext
        // this.checkOwnerContextErrorMessage = `L'owner deve iniziare per ${this.ownerContext}`
    }

    companyFormSchemaBase = () => {
        // const ownerContext = this.ownerContext;
        return Yup.object().shape({
            oid: Yup.number(),
            Id: Yup.number().label('Id').required(),
            BusinessName: Yup.string().label('BusinessName').required('Il Nome whatsNew è obbligatorio'),
            VatNumber: Yup.string().label('VatNumber').required('La Partita Iva è obbligatorio'),
            TaxCode: Yup.string().label('TaxCode').nullable(),
            UiLogoUrl: Yup.string().label('UiLogoUrl').nullable(),
            UiLogoBackground: Yup.string().label('UiLogoBackground').nullable(),
            UiHome: Yup.string().label('UiHome').nullable(),
            ApplicationName: Yup.string().label('ApplicationName').nullable(),
            ForfetariMenuName: Yup.string().label('ForfetariMenuName').nullable(),
            ConvMenuName: Yup.string().label('ConvMenuName').nullable(),
            BudgetMenuName: Yup.string().label('BudgetMenuName').nullable(),
            LogoutUrl: Yup.string().label('LogoutUrl').nullable(),
            IsFederated: Yup.boolean().label('Federata').nullable(),
            ImportEnabled: Yup.boolean().label('Import abilitato').nullable(),
            HasEasyStart: Yup.boolean().label('HasEasyStart').nullable(),
            // InsertDate: Yup.string().label('InsertDate'),
            // InsertUser: Yup.string().label('InsertUser'),
            // UpdateDate: Yup.string().label('UpdateDate'),
            // UpdateUser: Yup.string().label('UpdateUser'),
            })
    }        
}

export default {
    // newInEditWhatsNew,
    setCacheName,
    clearCache,
    reformatQuery,
}